import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer } from './price-plans.reducer';
import { PricePlansEffects } from './price-plans.effects';
import { pricePlansFeatureKey } from './price-plans.feature';

@NgModule({
  imports: [StoreModule.forFeature(pricePlansFeatureKey, reducer), EffectsModule.forFeature([PricePlansEffects])],
})
export class PricePlansStateModule {}
